import { airconFaqs as aeAircon, ptFaqs as aePt } from '../../data/markets/ae/faqs'
import { airconFaqs as abuDhabiAircon, ptFaqs as abuDhabiPt } from '../../data/markets/ae/faqs-abu-dhabi'
import { airconFaqs as myAircon, ptFaqs as myPt } from '../../data/markets/my/faqs'
import { marketKey } from '../../data/markets/registry'
import { resolveAll } from './content'

// FAQ depth for the UAE / Malaysia pages, matching the Singapore pages: each
// page keeps its own questions first, then takes market FAQs from the bank
// (data/markets/<cc>/faqs*.js) up to these counts. Abu Dhabi has its own bank.
export const FAQ_COUNTS = { hub: 14, page: 7, locality: 4 }

const AIRCON = { ae: aeAircon, 'ae/abu-dhabi': abuDhabiAircon, my: myAircon }
const PT = { ae: aePt, 'ae/abu-dhabi': abuDhabiPt, my: myPt }
const bankFor = (table, ctx) => table[marketKey(ctx.market.countryCd, ctx.city.slug)] ?? table[ctx.market.countryCd]

const norm = (q) => (q || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim()

// Lists in priority order; no question twice; at most `max`.
export const mergeFaqs = (max, ...lists) => {
    const seen = new Set()
    const out = []
    for (const list of lists) {
        for (const faq of list ?? []) {
            const key = norm(faq.question)
            if (!faq.question || seen.has(key)) continue
            seen.add(key)
            out.push(faq)
            if (out.length >= max) return out
        }
    }
    return out
}

// Which service FAQs a page gets, from its price panel.
export const serviceFaqKind = (panel = {}) => {
    if (panel.type === 'servicing' && panel.services?.length === 1) return panel.services[0]
    if (panel.type === 'gas') return 'gas'
    if (panel.type === 'repair') return 'repair'
    if (panel.type === 'annual') return 'annual'
    if (panel.type === 'priceTable') return 'price'
    return 'general'
}

// ctx: the page's content context (market, city, money, tables / lowest, pt).
export const airconFaqBank = (ctx) => {
    const raw = bankFor(AIRCON, ctx)(ctx)
    return {
        hub: resolveAll(raw.hub, ctx),
        service: Object.fromEntries(Object.entries(raw.service).map(([k, v]) => [k, resolveAll(v, ctx)])),
        locality: (place) => resolveAll(raw.locality(place), ctx),
    }
}

export const ptFaqBank = (ctx) => {
    const raw = bankFor(PT, ctx)(ctx)
    return { hub: resolveAll(raw.hub, ctx), topic: resolveAll(raw.topic, ctx) }
}
